import type { ZodIssue } from "zod";

import type { PydanticError, PydanticErrorDetail } from "@/types/errors";

function parsePydanticErrorDetail(detail: PydanticErrorDetail): string {
  const location = detail.loc.join(".");
  return `${location}: ${detail.msg}`;
}

export function parsePydanticError(error: PydanticError): Error {
  const messages = [];
  if (typeof error.detail === "string") {
    messages.push(error.detail);
  } else if (Array.isArray(error.detail)) {
    for (const err of error.detail) {
      messages.push(parsePydanticErrorDetail(err));
    }
  }
  return new Error(messages.join(", "));
}

function isValidJSON(str: string): boolean {
  try {
    JSON.parse(str);
    return true;
  } catch {
    return false;
  }
}

export function getAPIErrorMessage(error: unknown): string {
  if (error instanceof Error) {
    if (isValidJSON(error.message)) {
      return error.message;
    }
    return error.message || "Something went wrong. Try refreshing the page.";
  }
  return "Something went wrong. Try refreshing the page.";
}

export function parseZodIssues(zodIssues: ZodIssue[]): Record<string, string> {
  const issues: Record<string, string> = {};
  for (const issue of zodIssues) {
    issues[issue.path.join(".")] = issue.message;
  }
  return issues;
}
